var map = {
	"./layout-admin": 3311,
	"./layout-admin.vue": 3311,
	"./layout-default": 2597,
	"./layout-default.vue": 2597,
	"./layout-empty": 2868,
	"./layout-empty.vue": 2868,
	"./layout-error-404": 6376,
	"./layout-error-404.vue": 6376,
	"./layout-exterior": 3961,
	"./layout-exterior.vue": 3961,
	"./layout-hostadmin": 5069,
	"./layout-hostadmin.vue": 5069,
	"./layout-widget": 7990,
	"./layout-widget-no-design": 7318,
	"./layout-widget-no-design.vue": 7318,
	"./layout-widget.vue": 7990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6322;